import { Skeleton } from "@mui/material";

const SchedulePlaceHolder = () => {
  const x = [1, 2, 3, 4];
  return (
    <div className="flex flex-col space-y-5">
      {x.map((x) => (
        <div key={x} className="CardSchedule__container">
          <div className="flex flex-col space-y-10">
            <div className="flex items-center space-x-4">
              <Skeleton variant="circular" width={48} height={48} />
              <Skeleton variant="text" width={187} height={24} />
            </div>
            <div className="flex flex-wrap justify-between space-y-5 lg:space-y-[0px]">
              <Skeleton variant="rectangular" width={323} height={266} />
              <Skeleton variant="rectangular" width={323} height={266} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SchedulePlaceHolder;
